export default __webpack_public_path__ + "static/media/ESG-02.fea03629.jpg";